export const SET_MISSED_OPERATOR_MESSAGES = "SET_MISSED_OPERATOR_MESSAGES";
export const RESTORE_ALME_WINDOW = "RESTORE_ALME_WINDOW";


// WEBPACK FOOTER //
// ./modules/live-chat-foundation-missed-count/actions/actionTypes.ts